import React, { useEffect, useState } from "react";

// Indicatore di scorrimento (solo mobile) per liste tab scorrevoli orizzontalmente.
import { ChevronLeft, ChevronRight } from "lucide-react";
// Mostra una barra sotto le tab il cui "pollice" segue lo scorrimento del dito.
export const ScrollHint = ({ scrollRef }) => {
  const [s, setS] = useState({ w: 30, x: 0, show: false });
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const update = () => {
      const { scrollWidth, clientWidth, scrollLeft } = el;
      const show = scrollWidth > clientWidth + 4;
      const w = Math.max(20, (clientWidth / scrollWidth) * 100);
      const x = (scrollLeft / (scrollWidth - clientWidth || 1)) * (100 - w);
      setS({ w, x, show });
    };
    update();
    const t = setTimeout(update, 300);
    el.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => { clearTimeout(t); el.removeEventListener("scroll", update); window.removeEventListener("resize", update); };
  }, [scrollRef]);
  if (!s.show) return null;
  return (
    <div className="md:hidden mt-1.5 mb-1 h-1.5 w-full rounded-full bg-muted relative overflow-hidden" data-testid="tabs-scroll-hint" aria-hidden="true">
      <div className="absolute top-0 h-1.5 rounded-full bg-primary/50" style={{ width: `${s.w}%`, left: `${s.x}%`, transition: "left .08s linear, width .12s ease" }} />
    </div>
  );
};

// Frecce di scorrimento (tablet/desktop) sovrapposte ai bordi della lista tab scorrevole.
export const TabsScrollArrows = ({ scrollRef }) => {
  const [st, setSt] = useState({ left: false, right: false });
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const update = () => {
      const { scrollWidth, clientWidth, scrollLeft } = el;
      setSt({ left: scrollLeft > 4, right: scrollLeft < scrollWidth - clientWidth - 4 });
    };
    update();
    const t = setTimeout(update, 300);
    el.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => { clearTimeout(t); el.removeEventListener("scroll", update); window.removeEventListener("resize", update); };
  }, [scrollRef]);
  const scroll = (dir) => scrollRef.current && scrollRef.current.scrollBy({ left: dir * 240, behavior: "smooth" });
  return (
    <>
      {st.left && (
        <button type="button" onClick={() => scroll(-1)} aria-label="Scorri le schede a sinistra" data-testid="tabs-scroll-left"
          className="hidden sm:grid place-items-center absolute left-0 top-0 bottom-0 w-9 bg-gradient-to-r from-background via-background/90 to-transparent z-20">
          <span className="grid place-items-center h-7 w-7 rounded-full border bg-background shadow-sm hover:bg-secondary transition-colors"><ChevronLeft size={16} /></span>
        </button>
      )}
      {st.right && (
        <button type="button" onClick={() => scroll(1)} aria-label="Scorri le schede a destra" data-testid="tabs-scroll-right"
          className="hidden sm:grid place-items-center absolute right-0 top-0 bottom-0 w-9 bg-gradient-to-l from-background via-background/90 to-transparent z-20">
          <span className="grid place-items-center h-7 w-7 rounded-full border bg-background shadow-sm hover:bg-secondary transition-colors"><ChevronRight size={16} /></span>
        </button>
      )}
    </>
  );
};
